export default {
  namespaced: true,
  state: {
    document: false
  },
  getters: {
    document: (state) => state.document
  },
  actions: {
    setDocument ({ commit }, status) {
      commit('setDocument', status)
    }
  },
  mutations: {
    setDocument (state, status) {
      state.document = status
    }
  }
}
